import React from 'react'
import { string, number, object, array } from 'prop-types'
import { withTheme } from 'styled-components'
import { Flex, Box, Heading } from 'rebass'
import Image from '../Image'
import ContentQuoteBlock from '../ContentQuoteBlock'
import typography from '../../utils/typography'
import {
  IndustryHeading,
  CaseStudyLogo,
  CaseStudyImage,
  CaseStudyDetails,
  ContentFrameWithShadow
} from './components'
import buildImageUrl from '../../../lib/media-url-maker'

class ContentCaseStudy extends React.PureComponent {
  render() {
    // TODO
    // Use different image size for retina
    const bgimg =
      this.props.images &&
      this.props.images.length > 0 &&
      Object.assign(
        {},
        {
          x1: buildImageUrl({ resource: this.props.images[0] }),
          x2: buildImageUrl({ resource: this.props.images[0] })
        }
      )
    const logo = this.props.logo.length && this.props.logo[0]
    return (
      <ContentFrameWithShadow
        mt={[0, 0, typography.rhythm(2.5)]}
        mb={[
          typography.rhythm(1.5),
          typography.rhythm(2),
          typography.rhythm(3)
        ]}
        mx="auto"
        bg="white"
        as="article"
      >
        <Flex flexWrap="wrap" bg="white">
          {this.props.images && this.props.images.length > 0 && (
            <CaseStudyImage
              width={[1 / 1, 1 / 3]}
              order={this.props.order}
              bgimg={bgimg}
            />
          )}

          <CaseStudyDetails
            width={[1 / 1, 2 / 3]}
            pt={50}
            pb={30}
            pl={'7%'}
            pr={'12%'}
          >
            <Heading as="h3" f={7} mb={typography.rhythm(0.25)} pr={75}>
              {this.props.heading}
            </Heading>

            {this.props.subHeading && (
              <IndustryHeading mb={typography.rhythm(1)} f={4} as="h4" pr={75}>
                {this.props.subHeading}
              </IndustryHeading>
            )}

            {this.props.sell && this.props.sell}

            <CaseStudyLogo pt={50} mr={'12%'}>
              <Image
                resource={logo}
                alt={`${this.props.heading}`}
                width="100"
                mode="pad"
              />
            </CaseStudyLogo>
          </CaseStudyDetails>
        </Flex>

        {this.props.quotation && (
          <Box pt={typography.rhythm(1.5)} pl={'12%'} pr={'10%'}>
            <ContentQuoteBlock
              quote={this.props.quotation}
              quotee={this.props.quotationAuthor}
              mt={0}
              mb={0}
            />
          </Box>
        )}

        <Box bg="white" py={typography.rhythm(1.5)} pl={'12%'} pr={'10%'}>
          <div dangerouslySetInnerHTML={{ __html: this.props.body }} />
        </Box>
      </ContentFrameWithShadow>
    )
  }
}

ContentCaseStudy.defaultProps = {
  order: 0,
  img: { x1: '', x2: '' },
  heading: ''
}

ContentCaseStudy.propTypes = {
  img: object,
  heading: string,
  subHeading: string,
  industry: string,
  order: number,
  sell: string,
  quotation: string,
  quotationAuthor: string,
  body: string,
  images: array
}
export default withTheme(ContentCaseStudy)
